import javascript from "../Skills/javascript.svg";
import html from "../Skills/html.svg";
import css from "../Skills/css.svg";
import react from "../Skills/react.svg";
import nodejs from "../Skills/nodejs.svg";
import pgsql from "../Skills/pgsql.svg";
import typescript from "../Skills/typescript.svg";
import firebase from "../Skills/firebase.svg";
import github from "../Skills/github.svg";
import bootstrap1 from "../Skills/bootstrap1.png";
import express2 from "../Skills/express2.png";
import jest from "./jest.svg";
import Stack from "react-bootstrap/Stack";
import "bootstrap/dist/css/bootstrap.min.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";

export const Skills = () => {
	return (
		<div id='skills'>
			<div className='title-container'>
				<h2 className='section-title'>Skills</h2>
				<div className='title-line'></div>
			</div>
			<br />
			
			<Container className=' skills-imgs'>
			<Row>
				<Col className='skills-top-row'>
				
				<Image
							src={html}
							alt='Image 1'
							className='img-fluid skills-img '
						/>
					
						<Image
							src={javascript}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={css}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={bootstrap1}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={express2}
							alt='express'
							className='img-fluid skills-img express'
						/>
					
					
						<Image
							src={pgsql}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
					
					</Col>
				</Row>
				<Row>
					<Col>
			
			<Image
							src={nodejs}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={react}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={typescript}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={jest}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={firebase}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
				
						<Image
							src={github}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
				
					</Col>
					</Row>
					</Container>
			{/* <Image src={html} alt='Image 1' className='img-fluid skills-img ' />
			<Image src={html} alt='Image 1' className='img-fluid skills-img ' />
			<Image src={html} alt='Image 1' className='img-fluid skills-img ' />
			<Image src={html} alt='Image 1' className='img-fluid skills-img ' /> */}
			{/* <Container className='skills-imgs'>
				<Row>
					
						<Image
							src={html}
							alt='Image 1'
							className='img-fluid skills-img '
						/>
					
						<Image
							src={javascript}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={css}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={bootstrap1}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={express2}
							alt='express'
							className='img-fluid skills-img express'
						/>
					
					
						<Image
							src={pgsql}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
				</Row>
			</Container>
			<br />
			<Container>
				<Row>
					
						<Image
							src={nodejs}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={react}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={typescript}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={jest}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
						<Image
							src={firebase}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
				
						<Image
							src={github}
							alt='Image 2'
							className='img-fluid skills-img'
						/>
					
				</Row>
			</Container> */}
		</div>
	);
};
